import { fmtDate } from "@/lib/utils/charlie/constants";
import type { CharlieTask, TaskStatus } from "../types";

/** What the task action buttons ask the root to do. */
export type TaskAction = "complete" | "resched" | "cancel";

interface MyTasksProps {
  tasks: CharlieTask[];
  view: TaskStatus;
  setView: (v: TaskStatus) => void;
  onAction: (id: string, action: TaskAction) => void;
}

const TAB_LABEL: Record<TaskStatus, string> = {
  open: "Open",
  complete: "Completed",
  cancelled: "Cancelled",
};

/**
 * My tasks — everything the user accepted out of the brief. Deliberately
 * single-owner: there is no assignment field, because a task handed to someone
 * else in the system stops being the administrator's problem on screen while
 * still being theirs in reality. Delegation goes in the notes.
 */
export function MyTasks({ tasks, view, setView, onAction }: MyTasksProps) {
  return (
    <section className="card" style={{ marginBottom: 16 }}>
      <div className="lbl">
        My tasks <span className="n">all yours — delegate in notes, then mark complete</span>
      </div>

      <div className="tabs">
        {(["open", "complete", "cancelled"] as TaskStatus[]).map((v) => (
          <button key={v} className={view === v ? "on" : ""} onClick={() => setView(v)}>
            {TAB_LABEL[v]}
          </button>
        ))}
      </div>

      {tasks.length === 0 && <div className="empty">Nothing here.</div>}

      {tasks.map((t) => (
        <div key={t.id} className={"task " + t.status}>
          <button className="tk-chk" onClick={() => onAction(t.id, "complete")} aria-label="complete" />
          <div>
            <div className="tk-title">{t.title}</div>
            <div className="tk-meta">
              {t.bucketLabel} · {t.branch} · created {fmtDate(t.createdAt) || t.createdAt}
              {t.cancelReason ? ` · cancelled: ${t.cancelReason}` : ""}
            </div>
            {t.notes ? <div className="tk-note">"{t.notes}"</div> : null}
          </div>
          <div className="tk-right">
            <span className="due">{fmtDate(t.due)}</span>
            {t.status === "open" && (
              <div className="tk-acts">
                <button className="mini" onClick={() => onAction(t.id, "resched")}>Reschedule</button>
                <button className="mini" onClick={() => onAction(t.id, "cancel")}>Cancel</button>
              </div>
            )}
          </div>
        </div>
      ))}
    </section>
  );
}
